import { createContext } from "react";

import { MultiFormPromptsController } from "./MultiFormPromptsController.ts";

export const MultiFormPromptsContext =
  createContext<MultiFormPromptsController>({} as MultiFormPromptsController);
